// components/PageHeader.tsx
import { Box, Typography } from "@mui/material";

export function PageHeader({
  title,
  subtitle,
  right,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Box>
        <Typography
          component="h1"
          sx={{
            typography: { xs: "h5", md: "h4" },
            fontWeight: 700,
            letterSpacing: 0.2,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {right ? <Box>{right}</Box> : null}
    </Box>
  );
}
